import React, { Component } from 'react';
import Select from 'react-select'
import './multiSelect.scss';
import {Badge} from '@ecosystem/ui-lib/core/components/Badge';
import {Button} from 'app/components/Basics/'
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import Modal from 'app/components/Modal';

class MultiSelect extends Component {
    constructor(props){
        super(props);

        this.state = {
			selectedValues: this.props.selectedOptions,
			rangeStart: null,
            rangeEnd: null,
            showRangeSelectorsModal: false
        }
    }

	handleChange = (selectedOptions) => {		
		this.setState({ selectedValues: selectedOptions });
		this.props.onChange(selectedOptions);
	}

	showSelectedOptions() {
		this.props.selectedOptions.forEach((selectedOption) => {
			return <div>{selectedOption.value}</div>
		});
	}

	removeSelectedOption(option) {		
		var selectedValues = this.state.selectedValues;
		selectedValues = selectedValues.filter(function(f) { return f.value !== option.value })		
		this.setState({ selectedValues: selectedValues });
		this.props.onRemove(option);
	}

	badgeContent(option) {
		return (<div className='badge-content'>
					{option.label}
					<Button disabled={this.props.isDisabled} title="remove" onClick={()=> this.removeSelectedOption(option)} simple small icon={Icons.Close} />
				</div>)
	}

	selectAll() {
		this.setState({ selectedValues: this.props.options });
		this.props.onChange(this.props.options);
	}

	unselectAll() {
		this.setState({ selectedValues: [] });
		this.props.onChange([]);
	}

	handleRangeSelection = () => {
        const { rangeStart, rangeEnd } = this.state;
        const { options } = this.props;

        if (rangeStart && rangeEnd) {
            const startIndex = options.findIndex(option => option.value === rangeStart.value);
            const endIndex = options.findIndex(option => option.value === rangeEnd.value);

            if (startIndex < endIndex) {
				this.unselectAll();
                const selectedRange = options.slice(startIndex, endIndex + 1);
                this.setState({ selectedValues: selectedRange });
                this.props.onChange(selectedRange);
            }
        }
		this.showRangeSelectorsModal(false);
    }

	showRangeSelectorsModal(isVisible) {
		this.setState({ 
			showRangeSelectorsModal: isVisible,
			rangeStart: null,
			rangeEnd: null
		 });
	}

    render() {
		let menuPlament = "bottom";
		if (this.props.menuPlament && this.props.menuPlament==="top") {
			menuPlament = this.props.menuPlament;
		}
		
        return (
            <div>
				<div className="multi-select-component">				
					<Select 
						classNamePrefix='multi-select-box'
						closeMenuOnSelect={false}
						value={this.state.selectedValues}
						onChange={this.handleChange}
						options={this.props.options} 
						isMulti={true} 
						controlShouldRenderValue={false}
						isClearable={false}
						backspaceRemovesValue={false}
						isDisabled={this.props.isDisabled}
						menuPlacement={menuPlament}
						>
					</Select>
					{(this.props.showSelectAll || this.props.showSelectRange ) && (
						<div className="multi-select-selectors-btn form-row">
							<div className="form-row-left">
								{this.props.showSelectAll && (<Button title="Select All" onClick={()=> this.selectAll()} simple small>Select All</Button>)}
								{this.props.showSelectAll && (<Button title="Clear All" onClick={()=> this.unselectAll()} simple small>Clear All</Button>)}
								{this.props.showSelectRange && (<Button title="Select Range" onClick={() => this.showRangeSelectorsModal(true)} simple small>Select Range</Button>)}
							</div>
						</div>		
					)}

					<div className='selected-list'>					
						{this.props.selectedOptions && this.props.selectedOptions.map((option, i) => {
							if (option == null) return null;
							return (<Badge key={option.value} text={this.badgeContent(option)} className="selected-item-badge"></Badge> )
						})}
					</div>
				</div>

				{this.state.showRangeSelectorsModal && (<Modal size="small" 					
					cancelButtonLabel="Close" cancelModalHandler={this.showRangeSelectorsModal.bind(this, false)}
					confirmButtonLabel="Apply" confirmModalHandler={this.handleRangeSelection.bind(this)} 
					content={<div style={{ minWidth: '400px'}}>						
						<div className='form-row'>
							<h3>Select Range</h3>
						</div>
						<div className="multi-select-selectors-btn form-row">
							<div className="form-row-left">
								<div style={{ minWidth: '200px'}}>
									<Select
										classNamePrefix='range-select-box'
										value={this.state.rangeStart}
										onChange={(option) => this.setState({ rangeStart: option })}
										options={this.props.options}
										isClearable={true}
										placeholder="Select start"
									/>
								</div>
								<div style={{ minWidth: '200px'}}>
									<Select
										classNamePrefix='range-select-box'
										value={this.state.rangeEnd}
										onChange={(option) => this.setState({ rangeEnd: option })}
										options={this.props.options}
										isClearable={true}
										placeholder="Select end"
									/>
								</div>
							</div>
							
						</div>
						
					
                    
					
                   
					</div>}  />)}
			</div>
        );
    }
}
export default MultiSelect;